import store from '../store'

function getType(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1)
}


export default {
  inserted(el, binding, vnode) {
    let {value} = binding;
    let apiList = store.getters && store.getters.apiList;
    if (!apiList || !apiList.length) {
      return
    }
    let hasPermission = false;
    let api=value.api;
    if(getType(api)==='Array'){
      for(let i=0,len=api.length;i<len;i++){
        if(apiList.indexOf(api[i])!==-1){
          hasPermission=true;
          break;
        }
      }
    }
    if(getType(api)==='String'){
      if(apiList.indexOf(api)!==-1){
        hasPermission=true
      }
    }
    if (!hasPermission) {

      el.parentNode && el.parentNode.removeChild(el)
      if(!el.parentNode){
        el.innerHTML=''
        el.style.display='none'
      }


    }

  }
}
